module.exports = __webpack_public_path__ + "media/music1.583923a1.mp3";